<template lang="pug">
.m-card
  .m-card-header(:id="'heading-ouoe-' + id" :data-bs-target="'#collapse-ouoe-' + id" :aria-controls="'collapse-ouoe-' + id" data-bs-toggle='collapse' role='button' aria-expanded='false')
    .group
      .league-name {{ $tc("m.BT_OUOE", 1) }}
  .m-card-body.collapse.show(:id="'collapse-ouoe-' + id" :aria-labelledby="'heading-ouoe-' + id" aria-expanded='false')
    .m-card-item(:class="{ 'live' : marketType == 3 }")
      .m-card-wrap
        .odds-wrapper(v-if="mode == 0 || mode == 1")
          .m-label-wrap
            .m-label F.T  
          .odds-group
            .col
              template(v-for="item in col1")
                template(v-if="moreItems['ouoeo'][item] && moreItems['ouoeo'][item][5] != 0 && moreItems['ouoeo'][item][5] != ''")
                  OddsItem(:odds="moreItems['ouoeo'][item]" idx=5 :typ="oddsType" dataType="3" :label="getLabel(item)")
                template(v-else)
                  OddsDisabled
            .col
              template(v-for="item in col2")
                template(v-if="moreItems['ouoeo'][item] && moreItems['ouoeo'][item][5] != 0 && moreItems['ouoeo'][item][5] != ''")
                  OddsItem(:odds="moreItems['ouoeo'][item]" idx=5 :typ="oddsType" dataType="3" :label="getLabel(item)")
                template(v-else)
                  OddsDisabled
//- .card.market-card
//-   .card-header.bg-more-head.collapse-more(
//-     :id="'heading-ouoe-' + id"
//-     data-toggle='collapse'
//-     :data-target="'#collapse-ouoe-' + id"
//-     :aria-controls="'collapse-ouoe-' + id"
//-     aria-expanded=true
//-   )
//-     .flex-grow-1.text-ellipsis.text-uppercase.mr-2 {{ $t("m.BT_OUOE") }}
//-   .collapse.show(
//-     :aria-labelledby="'heading-ouoe-' + id"
//-     :id="'collapse-ouoe-' + id"
//-   )
//-     .card-body.p-0
//-       .market-card-content
//-         .normal(v-if="mode == 0 || mode == 1")
//-           .normal-title {{ $t("ui.full_time") }}
//-           .normal-odd-area
//-             .normal-odd-area-group(v-for="item in col")
//-               .normal-odd-area-oddtype.text-center.mr-0 {{ $t("m.BK_" + item) }} ({{ moreItems['ouoeo'][item][7] }})
//-               template(v-if="moreItems['ouoeo'][item] && moreItems['ouoeo'][item][5] != 0 && moreItems['ouoeo'][item][5] != ''")
//-                 OddsItem(:odds="moreItems['ouoeo'][item]" idx=5 :typ="oddsType" dataType="3" :details="moreItems" mode="ouoeo")
//-               template(v-else)
//-                 OddsDisabled
</template>

<script>
import OddsItem from "@/components/mobile/main/xitem/oddsItem";
import OddsDisabled from "@/components/mobile/main/xitem/oddsDisabled";
import mixinHDPOUOdds from "@/library/mixinHDPOUOdds";

export default {
  components: {
    OddsItem,
    OddsDisabled
  },
  mixins: [mixinHDPOUOdds],
  props: {
    mode: {
      type: Number
    }
  },
  data() {
    return {
      col1: ["OO", "OE"],
      col2: ["UO", "UE"],
    }
  },
  methods: {
    getLabel(x) {
      if(this.moreItems['ouoeo'][x] && this.moreItems['ouoeo'][x][7] && this.moreItems['ouoeo'][x][7] != '') {
        return this.$t("m.BK_" + x) + ' (' + this.moreItems['ouoeo'][x][7] + ')';
      }
      return this.$t("m.BK_" + x);
    },
  }
}
</script>
